import { Maybe, UserRelation } from '@aibees/shared/definition';
import { useMemo } from 'react';
import { useWorkspace } from '../context';

type MinimalUser = Pick<UserRelation, 'id' | 'firstName' | 'lastName'>;

export function useGetUpdatedUser<T extends Maybe<MinimalUser>>(user: T): T {
  const workspace = useWorkspace();

  return useMemo(() => {
    if (!user?.id || !workspace) return user;

    const fresh =
      workspace.members.find((m) => m.user?.id === user.id)?.user ??
      (workspace.user.id === user.id ? workspace.user : undefined);

    if (!fresh) return user;
    if (
      fresh.firstName === user.firstName &&
      fresh.lastName === user.lastName
    ) {
      return user;
    }

    return { ...user, firstName: fresh.firstName, lastName: fresh.lastName };
  }, [user, workspace]);
}
